const getRequisitionPrintTemplate = (data) => {

  const req = data.requisition || {};   // ✅ FIX

  const formatDateTime = (dateString) => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  const toInitCap = (text) => {
    if (!text) return "-";

    return text
      .toLowerCase()
      .split(" ")
      .map(word => {
        if (word === "po") return "PO"; // keep PO uppercase
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  };

  const reportData = data.items || [];

  const approvalItem = reportData.find(
    item =>
      item.approvedByAdmin ||
      item.approvedBySuperAdmin ||
      item.approvedByBoss
  ) || {};

  const adminName = approvalItem.approvedByAdmin || "";
  const adminDate = approvalItem.adminApprovedAt || "";

  const superAdminName = approvalItem.approvedBySuperAdmin || "";
  const superAdminDate = approvalItem.superAdminApprovedAt || "";

  const bossName = approvalItem.approvedByBoss || "";
  const bossDate = approvalItem.bossApprovedAt || "";

  return `
<html lang="en">
<head>
<meta charset="utf-8"/>
<meta name="viewport" content="width=device-width, initial-scale=1.0"/>
<title>Requisition</title>
</head>

<body style="background-color:#f7fafc; padding:16px;">
<div style="max-width:1024px; margin:0 auto; background:white; padding:24px; box-shadow:0 4px 6px rgba(0,0,0,0.1);">

<!-- HEADER -->
<div style="margin-bottom:16px;">
  <div style="display:flex; justify-content:space-between;">
    <div>
      <h1 style="font-size:1.25rem; font-weight:bold;">
        Indigo Infraprojects Pvt. Ltd.
      </h1>
      <p style="font-size:0.875rem;">
        Dwarka, New Delhi - 110075
      </p>
    </div>

    <img 
      src="https://indigoinfra.in/img/product/product-1739471679615.jpeg" 
      width="110"
    />
  </div>

  <div style="text-align:center; margin-top:10px;">
    <h2 style="font-weight:bold; text-transform:uppercase;">
      Requisition (Digital Copy)
    </h2>
  </div>
</div>

<!-- STATUS -->
${(() => {
      const rawStatus = req.status;

      let statusText = rawStatus;

      if (rawStatus === "open") {
        statusText = "Open";
      }
      else if (rawStatus === "submit") {
        statusText = "Pending With Project Manager";
      }
      else if (rawStatus === "adminSubmit") {
        statusText = "Pending With Central Team";
      }
      else if (rawStatus === "pendingWithBoss") {
        statusText = "Pending With HO";
      }
      else if (rawStatus === "close") {
        statusText = "Closed";
      }
      else {
        // ✅ If no mapping exists, show the actual DB status
        statusText = rawStatus || "-";
      }

      return `
  <div style="display:flex; justify-content:space-between; margin-bottom:16px;">
    <div>
      <p>Req No : <strong>${req.requisitionNo || "-"}</strong></p>
      <p>Requested By : ${req.requestedBy?.toUpperCase() || "-"}</p>
      <p>Status : <strong>${statusText || "-"}</strong></p>
    </div>

    <div>
      <p>Project Code : ${req.storeCode || "-"}</p>
      <p>Project Name : ${req.storeName?.toUpperCase() || "-"}</p>
      <p>Date : <strong>${formatDateTime(req.createdAt)}</strong></p>
    </div>
  </div>
  `;
    })()}

<!-- TABLE -->
<table style="width:100%; border-collapse:collapse; border:1px solid #cbd5e0;">
<thead>
<tr>
  <th style="border:1px solid #cbd5e0; padding:8px;">S.No</th>
  <th style="border:1px solid #cbd5e0; padding:8px;">Part No</th>
  <th style="border:1px solid #cbd5e0; padding:8px;">Description</th>
  <th style="border:1px solid #cbd5e0; padding:8px;">Unit</th>
  <th style="border:1px solid #cbd5e0; padding:8px;">Req Qty</th>
  <th style="border:1px solid #cbd5e0; padding:8px;">Appr Qty</th>
  <th style="border:1px solid #cbd5e0; padding:8px;">Received Qty</th>
  <th style="border:1px solid #cbd5e0; padding:8px;">PO No</th>
  <th style="border:1px solid #cbd5e0; padding:8px;">Status</th>
</tr>
</thead>

<tbody>

${reportData.length === 0
      ? `<tr>
         <td colspan="9" style="text-align:center;">No Items Found</td>
       </tr>`
      : reportData.map((item, index) => {
        let itemStatus = item.status || "-";
        // ✅ Pending with HO (waiting for Director approval)
        if (item.status === "approvedBySuperAdmin") {
          itemStatus = "Pending With HO";
        }
        // ✅ Pending with Central Team
        if (item.status === "approvedByAdmin") {
          itemStatus = "Pending With Central Team";
        }

        // ✅ APPROVED LOGIC
        if (item.status === "approved") {

          // ❌ NO PO
          if (!item.poNumber) {
            itemStatus = "Pending Local Order";
          }

          // ✅ PO EXISTS → CHECK PO STATUS
          else {

            const poStatus = item.poStatus;

            if (poStatus === "Generated" || poStatus === "Assigned-To-Checker") {
              itemStatus = "Pending With PO Checker";
            }

            else if (poStatus === "Assigned-To-Maker") {
              itemStatus = "Pending With PO Maker";
            }

            else if (poStatus === "Assigned-To-SuperAdmin") {
              itemStatus = "Pending With HO";
            }

            else if (poStatus === "Confirmed-Generated") {
              itemStatus = "Pending PO Order";
            }

            else {
              // ✅ fallback (your previous logic)
              itemStatus = "Pending PO Order";
            }
          }
        }

        // ✅ RECEIVED
        else if (item.status === "recived") {
          itemStatus = "Order Received";
        }

        // ✅ ALL OTHER STATUS → NO CHANGE (DB VALUE)



        return `
<tr>
  <td style="border:1px solid #cbd5e0; padding:8px;">${index + 1}</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">${item.partNo || "-"}</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">${item.description || "-"}</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">${item.unit || "-"}</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">${item.qtyRequired || 0}</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">${item.approveQty || 0}</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">${item.qtyRecived || 0}</td>

  <td style="border:1px solid #cbd5e0; padding:8px;">
    ${item.poNumber || "LOCAL"}
  </td>

  <td style="border:1px solid #cbd5e0; padding:8px;">${itemStatus || "-"}</td>
</tr>
`;
      }).join("")}
</tbody>
</table>

<!-- FOOTER -->
<div style="margin-top:32px;">
  <div style="display:flex; justify-content:space-between;">

    <div style="width:25%;">
      <p>Prepared By</p>
      <strong>${req?.requestedBy?.toUpperCase() || "-"}</strong>
      <p>Date : ${formatDateTime(req.createdAt)}</p>
    </div>

    <div style="width:25%; text-align:center;">
      <p>Project Manager</p>
      <strong>${adminName || "________"}</strong>
      <p>${adminDate ? formatDateTime(adminDate) : ""}</p>
    </div>

    <div style="width:25%; text-align:center;">
      <p>Central Team</p>
      <strong>${superAdminName || "________"}</strong>
      <p>${superAdminDate ? formatDateTime(superAdminDate) : ""}</p>
    </div>

    <div style="width:25%; text-align:right;">
      <p>Head Office</p>
      <strong>${bossName || "________"}</strong>
      <p>${bossDate ? formatDateTime(bossDate) : ""}</p>
    </div>

  </div>
</div>

</div>
</body>
</html>
`;
};

export default getRequisitionPrintTemplate;